import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function FeatureThreeIcon(props: IconProps) {
  return (
    <Icon width="60px" height="60px" viewBox="0 0 60 60" fill="none" {...props}>
      <Box as="circle" cx="30" cy="30" r="29.25" stroke="currentColor" strokeWidth="1.5" />
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.442"
        d="M27.448 33.552 18 42.999m0 0h9.448M18 43v-9.447m15.553-6.105L43 18m0 0h-9.448M43 18v9.448m-25-7.936c0-.53 0-.794.103-.996a.945.945 0 0 1 .413-.413c.202-.103.467-.103.996-.103h6.424c.53 0 .794 0 .996.103.178.09.322.235.413.413.103.202.103.467.103.996v6.424c0 .53 0 .794-.103.996a.945.945 0 0 1-.413.413c-.202.103-.467.103-.996.103h-6.424c-.53 0-.794 0-.996-.103a.945.945 0 0 1-.413-.413C18 26.73 18 26.465 18 25.936v-6.424Zm15.553 15.551c0-.529 0-.794.103-.996a.945.945 0 0 1 .413-.413c.202-.103.466-.103.995-.103h6.425c.53 0 .794 0 .996.103a.952.952 0 0 1 .413.413c.103.203.103.467.103.996v6.424c0 .53 0 .794-.103.996a.945.945 0 0 1-.413.413c-.202.103-.467.103-.996.103h-6.425c-.529 0-.793 0-.995-.103a.945.945 0 0 1-.413-.413c-.103-.202-.103-.466-.103-.995v-6.425Z"
      />
    </Icon>
  );
}
